import React, { useEffect } from "react";
import CardPage from "../../../layout/CardPage";
import { useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { startGetConcesionariosServicio } from "../../../context/actions/concesionariosActions";
import { Detalle } from "./_Detalle";
import { startGetHistorial } from "../../../context/actions/historialActions";
import { ConfigProvider } from "antd";

export const ConsesionariosDetalle = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const readOnly = useSelector((state) => state.userReducer.user?.esSoloLectura) === "soloLectura";

  useEffect(() => {
    dispatch(startGetConcesionariosServicio(id));
    dispatch(startGetHistorial(id, 1));
  }, []);

  const handleRegresar = () => navigate("/ConsesionariosServicios");
  return (
    <ConfigProvider componentDisabled={readOnly}>
      <CardPage
        titulo="Servicio Concesionado"
        tituloBoton="regresar"
        accionBoton={handleRegresar}
      >
        <Detalle />
      </CardPage>
    </ConfigProvider>
  );
};
